import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Logo } from '@/components/Logo';
import { Button } from '@/components/ui/button';

/**
 * Shown when the user has a session but app_metadata.approved is not true.
 * With the Custom Access Token hook denying tokens for unapproved users,
 * this is an edge case (e.g. if hook was briefly disabled).
 */
export default function PendingApproval() {
  const { user, signOut } = useAuth();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-wt-bg-primary text-wt-text-primary p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <Link to="/" className="inline-flex items-center justify-center mb-4">
          <Logo variant="fullTransparent" size="h-16" />
        </Link>
        <h1 className="font-sans text-2xl font-bold text-wt-text-primary">
          Account pending approval
        </h1>
        <p className="font-sans text-wt-text-secondary">
          Your account has been created. An administrator will approve your access soon.
          You’ll be able to sign in once approved.
        </p>
        {user?.email && (
          <p className="font-sans text-sm text-wt-text-muted">
            Signed up as {user.email}
          </p>
        )}
        <Button
          type="button"
          variant="outline"
          className="border-wt-border-default text-wt-text-secondary hover:bg-wt-bg-tertiary"
          onClick={() => signOut()}
        >
          Sign out
        </Button>
        <p className="font-sans text-xs text-wt-text-muted">
          <Link to="/login" className="text-primary hover:underline">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
